import AccessGuard from './AccessGuard'

export default AccessGuard
